
import { CarListing, NavigationItem, DealerNavigationItem } from '../types/dealership';

export const NAVIGATION_ITEMS: NavigationItem[] = [
  { id: 'profile', label: 'Profile' },
  { id: 'listings', label: 'Current Listings' },
  { id: 'addCars', label: 'Add New Cars' }
];

export const DEALER_NAVIGATION_ITEMS: DealerNavigationItem[] = [
  { 
    id: 'profile', 
    name: 'Profile',
    iconName: 'User'
  },
  { 
    id: 'listings', 
    name: 'Current Listings',
    iconName: 'Car'
  },
  { 
    id: 'addCars', 
    name: 'Add New Cars',
    iconName: 'Plus'
  }
];

export const MOCK_CAR_LISTINGS: CarListing[] = [
  {
    id: '1',
    model: '2023 Toyota Camry',
    type: 'Sedan',
    price: '$28,999',
    creditScore: '650+',
    sellerInfo: 'Verified Dealer',
    financingTerm: '72 Months',
    carName: '2023 Toyota Camry LE',
    carMake: 'Toyota',
    carModel: 'Camry',
    carBrand: 'Toyota',
    mileage: '15000',
    fuelType: 'gasoline',
    transmission: 'automatic',
    vin: '4T1B11HK5PU123456',
    exteriorColor: 'Pearl White',
    interiorColor: 'Black Fabric',
    carDescription: 'Excellent condition Toyota Camry with low mileage. One owner vehicle with full service history. This sedan offers exceptional fuel economy and reliability, perfect for daily commuting and family trips.',
    msrp: '$28,999',
    minCreditScore: '650',
    termDuration: '72',
    monthlyPayment: '425',
    otherRequirements: 'Proof of income required. Trade-ins accepted.',
    carImages: [],
    drivetrain: 'FWD',
    year: '2023',
    dealerInfo: {
      name: 'Premier Toyota – Downtown',
      address: '456 Main Street, Toronto, ON',
      hours: 'Mon–Sat, 9am–7pm',
      email: 'sales@premiertoyota.com',
      phone: '+1 (416) 555-0123'
    },
    listingNumber: 'TOY2023CAMRY001'
  },
  {
    id: '2',
    model: '2022 Honda Accord',
    type: 'Sedan',
    price: '$26,500',
    creditScore: '620+',
    sellerInfo: 'Certified Pre-Owned',
    financingTerm: '60 Months',
    carName: '2022 Honda Accord Sport',
    carMake: 'Honda',
    carModel: 'Accord',
    carBrand: 'Honda',
    mileage: '22000',
    fuelType: 'gasoline',
    transmission: 'manual',
    vin: '1HGCV1F16NA234567',
    exteriorColor: 'Sonic Gray Pearl',
    interiorColor: 'Black Leather',
    carDescription: 'Honda Certified Pre-Owned vehicle with extended warranty. Sport trim with upgraded features including leather seats, sunroof, and advanced safety technology.',
    msrp: '$26,500',
    minCreditScore: '620',
    termDuration: '60',
    monthlyPayment: '485',
    otherRequirements: 'Down payment of $2,000 required.',
    carImages: [],
    drivetrain: 'FWD',
    year: '2022',
    dealerInfo: {
      name: 'Honda City – North York',
      address: '789 Yonge Street, North York, ON',
      hours: 'Mon–Fri, 9am–8pm, Sat 9am–6pm',
      email: 'info@hondacity.ca',
      phone: '+1 (416) 555-0456'
    },
    listingNumber: 'HON2022ACCORD002'
  },
  {
    id: '3',
    model: '2024 Nissan Altima',
    type: 'Sedan',
    price: '$32,199',
    creditScore: '680+',
    sellerInfo: 'New Car Dealer',
    financingTerm: '84 Months',
    carName: '2024 Nissan Altima SV',
    carMake: 'Nissan',
    carModel: 'Altima',
    carBrand: 'Nissan',
    mileage: '0',
    fuelType: 'gasoline',
    transmission: 'cvt',
    vin: '1N4BL4BV5PC345678',
    exteriorColor: 'Brilliant Silver Metallic',
    interiorColor: 'Charcoal Cloth',
    carDescription: 'Brand new 2024 Nissan Altima with full manufacturer warranty. SV trim with advanced safety features, ProPILOT Assist, and intelligent all-wheel drive.',
    msrp: '$32,199',
    minCreditScore: '680',
    termDuration: '84',
    monthlyPayment: '395',
    otherRequirements: 'Qualified buyers only. Manufacturer incentives available.',
    carImages: [],
    drivetrain: 'AWD',
    year: '2024',
    dealerInfo: {
      name: 'Nissan Markham',
      address: '321 Highway 7, Markham, ON',
      hours: 'Mon–Sat, 9am–8pm',
      email: 'sales@nissanmarkham.com',
      phone: '+1 (905) 555-0789'
    },
    listingNumber: 'NIS2024ALTIMA003'
  },
  {
    id: '4',
    model: '2021 Hyundai Elantra',
    type: 'Sedan',
    price: '$19,995',
    creditScore: '600+',
    sellerInfo: 'Trade-In Special',
    financingTerm: '48 Months',
    carName: '2021 Hyundai Elantra SEL',
    carMake: 'Hyundai',
    carModel: 'Elantra',
    carBrand: 'Hyundai',
    mileage: '35000',
    fuelType: 'gasoline',
    transmission: 'automatic',
    vin: 'KMHL14JA5MA456789',
    exteriorColor: 'Intense Blue',
    interiorColor: 'Gray Cloth',
    carDescription: 'Well-maintained Elantra with remaining factory warranty. Great fuel economy and reliability. This compact sedan is perfect for first-time buyers or city driving.',
    msrp: '$19,995',
    minCreditScore: '600',
    termDuration: '48',
    monthlyPayment: '435',
    otherRequirements: 'Trade-in bonus available. First-time buyer programs accepted.',
    carImages: [],
    drivetrain: 'FWD',
    year: '2021',
    dealerInfo: {
      name: 'Hyundai Central',
      address: '654 Queen Street, Toronto, ON',
      hours: 'Tue–Sat, 10am–7pm',
      email: 'contact@hyundaicentral.com',
      phone: '+1 (416) 555-0321'
    },
    listingNumber: 'HYU2021ELANTRA004'
  }
];